import { useAuth } from '@/lib/platform/AuthProvider';
import { useAppNavigation } from '@/lib/platform';
import { useEffect } from 'react';
import { useProfile } from '@/lib/api';
import { Loader } from '@/components/Loader';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { isSignedIn, isLoaded, openSignIn } = useAuth();
  const { navigate } = useAppNavigation();

  // Check if user is admin (only fetch when signed in)
  const { data: profile, isLoading } = useProfile({
    enabled: isSignedIn && isLoaded,
  });

  const isAdmin = profile?.data?.isAdmin;

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      openSignIn({ preventClose: true });
    } else if (!isLoading && isSignedIn && !isAdmin) {
      navigate('/dashboard');
    }
  }, [isLoaded, isSignedIn, isLoading, isAdmin, navigate, openSignIn]);

  if (!isLoaded || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!isSignedIn || !isAdmin) {
    return null;
  }

  return <>{children}</>;
}

